import React, { useEffect, useState } from 'react';
import OverviewCard from '../../components/OverviewCard';
import SalesFilter from './SalesFilter';
import SalesChart from './SalesChart';
import { Apirequests } from '../../utils/ApiRequests';
import SpinningLogo from '../../components/Spinner';


const Dashboard = () => {
  const [data, setData] = useState(null);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);


  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await Apirequests(`home/dashboard?startDate=${startDate}&endDate=${endDate}`, "GET", {}, {
        Authorization: `Bearer ${token}`,
      });
      // console.log(response,'response')
      if (response?.success) {
        setData(response?.data)
      } else {
        setData(null)
      }
    } catch (error) {
      console.log(error, 'dashboard data fetch error');
    }
    setLoading(false)
  };

  useEffect(() => {
    fetchData()
  }, []);

   if (loading) {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <SpinningLogo />
    </div>
  }

  return (
    <div className="p-6">
      <h1 className="text-3xl font-semibold text-gray-800 mb-6">Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <OverviewCard title="Total Users" value={data?.totalUsers} icon="users" />
        <OverviewCard title="Total Courses" value={data?.totalCourses} icon="course" />
        <OverviewCard title="Total Revenue" value={Math.floor(data?.allTimeNetReceivedAmount)} icon="rupee-sign" titleColor={"text-green-500"} valueColor={"text-green-500"}/>
        <OverviewCard title="Total Failed" value={data?.allTimeFailedAmount} icon="rupee-sign" titleColor={"text-red-500"} valueColor={"text-red-500"}/>
       
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {/* <ChartCard title="Sales Overview" /> */}
        {/* <TableCard title="Recent Orders" /> */}
        <SalesChart />
        <SalesFilter startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} fetchData={fetchData} data={data}/>
      </div>
    </div>
  );
};

export default Dashboard;

